import { render, staticRenderFns } from "./UserPromotions.vue?vue&type=template&id=1ac6fc2c&"
import script from "./UserPromotions.vue?vue&type=script&lang=ts&"
export * from "./UserPromotions.vue?vue&type=script&lang=ts&"
import style0 from "./UserPromotions.vue?vue&type=style&index=0&id=1ac6fc2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports